// extracted by mini-css-extract-plugin
module.exports = {"page":"NotFoundPage_page__1XecM","error_block":"NotFoundPage_error_block__3FCeR","text":"NotFoundPage_text__2u6sa"};